import { FC } from 'react';
import { useTranslation, Trans } from 'next-i18next';
import {
  NEXT_STATIC_IMAGES,
  GMB_SUPPORT_EMAIL,
  GMB_SUPPORT_PHONE_NUMBER,
} from 'src/common/constants';
import formatTel from 'src/common/utils/formatTel';
import PitchPageLayout from 'src/common/components/PitchPageLayout';
import Typography from 'src/common/components/Typography';
import UniversalLink from 'src/common/components/UniversalLink';
import styles from './Hero.module.scss';

const Hero: FC = () => {
  const [t] = useTranslation('contact-us');

  return (
    <PitchPageLayout
      backgroundColor="ivory"
      variant="header"
    >
      <div className={styles.root}>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          src={`${NEXT_STATIC_IMAGES}contact-us/intro-graphic.svg`}
          width={168}
          height={80}
          alt={t('hero--title')}
          loading="eager"
        />
        <div className={styles.title}>
          <Typography
            type="h1"
            size="display-4"
            sizeFromBreakpointM="display-3"
          >
            {t('hero--title')}
          </Typography>
        </div>
        <div className={styles.text}>
          <Typography type="p" size="body-xl">
            <Trans
              t={t}
              i18nKey="hero--text"
              values={{
                supportEmail: GMB_SUPPORT_EMAIL,
                supportPhone: formatTel(GMB_SUPPORT_PHONE_NUMBER),
              }}
              components={{
                break: <br />,
                emailLink: (
                  <UniversalLink
                    className={styles.link}
                    href={`mailto:${GMB_SUPPORT_EMAIL}`}
                  />
                ),
                phoneLink: (
                  <UniversalLink
                    className={styles.link}
                    href={`tel:${GMB_SUPPORT_PHONE_NUMBER}`}
                  />
                ),
              }}
            />
          </Typography>
        </div>
      </div>
    </PitchPageLayout>
  );
};

export default Hero;
